// Whether the learner is in the middle of a recording, shared by every place
// that can play tutor audio outside the pill's own transport.
//
// The phrase replay controls (a phrase tap, the repeat loop, the pill's replay
// button and the snapped scrub release) must never start Arti's voice while the
// learner is recording, because the microphone would pick it up. The recorder's
// own state is component-local data in AudioRecorder.vue, so it writes this
// store instead, and the playback service and the controls read it.
//
// A "take" is in progress from the record tap (before the microphone has even
// answered) until the recording is sent, discarded or abandoned. That includes
// the held state, in which the capture has stopped but the learner has not yet
// decided what to do with it: a loop restarting there would talk over the
// learner's decision, and the next action may resume the recording.
//
// Several recorder hosts can be mounted at once (a chat and Daily Play each
// mount one), so the store keeps one entry per host and a take is in progress
// while any host has one. A host that unmounts clears only its own entry.
//
// Kept in its own module, importing nothing but Vue, so that the playback
// service can read it and tests/unit/audioRecorder.test.js, which mocks the
// whole playback service, is unaffected.

import { reactive } from "vue";

export const recordingState = reactive({
  takeInProgress: false,
});

const activeHosts = new Set();

/**
 * Records whether one recorder host has a take in progress.
 * @param {*} host any value that identifies the host, such as a Symbol it
 *   created for itself
 * @param {boolean} active
 */
export function setTakeInProgress(host, active) {
  if (active) {
    activeHosts.add(host);
  } else {
    activeHosts.delete(host);
  }
  recordingState.takeInProgress = activeHosts.size > 0;
}
